import React from "react";

import { FormattedMessage, MessageDescriptor } from "react-intl";

import ArrowUpRightIcon from "@atlaskit/icon/core/arrow-up-right";
import { Anchor, xcss, Inline, Text } from "@atlaskit/primitives-next";

import { useResourcesPageUIAnalytics } from "../hooks";

const anchorStyle = xcss({
    "display": "flex",
    "flexGrow": 1,
    "alignItems": "center",
    "gap": "space.100",
    "color": "color.text",
    "backgroundColor": "elevation.surface",
    "textDecoration": "none",
    "borderRadius": "border.radius.200",
    "borderWidth": "border.width",
    "borderStyle": "solid",
    "borderColor": "color.border",

    ":hover": {
        color: "color.text",
        backgroundColor: "elevation.surface.hovered",
        textDecoration: "none",
        boxShadow: "elevation.shadow.raised"
    }
});

export interface LinkCardProps {
    id: string;
    icon: React.ReactElement;
    text: MessageDescriptor;
    href: string;
}

export const LinkCard: React.FC<LinkCardProps> = ({ id, icon, text, href }) => {
    const { sendUsefulLinkClickUIEvent } = useResourcesPageUIAnalytics();

    return (
        <Anchor
            href={href}
            target="_blank"
            xcss={anchorStyle}
            paddingBlock="space.075"
            paddingInline="space.150"
            onClick={() => sendUsefulLinkClickUIEvent(id)}
        >
            {icon}
            <Inline grow="fill">
                <Text>
                    <FormattedMessage {...text} />
                </Text>
            </Inline>
            <ArrowUpRightIcon label="" spacing="spacious" />
        </Anchor>
    );
};
